import { useEffect, useState } from 'react';

import { uniqueId } from 'lodash';

export const useRefreshKey = (value: unknown): string => {
  const [key, setKey] = useState(() => uniqueId());

  // biome-ignore lint/correctness/useExhaustiveDependencies: Refresh key on value change
  useEffect(() => {
    setKey(uniqueId());
  }, [
    value,
  ]);

  return key;
};
